import {
    Link,
    Spacer,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    Text,
    useToast,
    VStack
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useMutation } from "react-query";
import { Button } from "../../../components/atoms/Button";
import { Input } from "../../../components/atoms/Input";
import { PasswordInput } from "../../../components/atoms/PasswordInput";
import { RFHMaskedInput } from "../../../components/atoms/RFHMaskedInput";
import { Title } from "../../../components/atoms/Title";
import { login as loginFunc } from "../../../api/login";
import { useTheme } from "../../../context";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useLogin } from "../context/login.context";

export function Login() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [username, setUsername] = useState();
    const { login } = useLogin();
    const [password, setPassword] = useState();
    const { id, name, bookstoreType, bookstoreModule } = useTheme();
    const toast = useToast();
    const loginMutation = useMutation(() => loginFunc(id, username, password), {
        onSuccess({ data, status }) {
            if (status === 400)
                return toast({
                    title: "Oops!",
                    description: data.error,
                    status: "error"
                });
            login(data.token, data.user);
            if (searchParams.get("redirectUrl")){
                navigate(searchParams.get("redirectUrl"))
            }else {
                navigate("/")
            }
        },
        onError() {
            toast({
                title: "Oops!",
                description:
                    "Esta combinação de email/cpf e senha não existe! Verifique seus dados e tente novamente",
                status: "error"
            });
        }
    });

    return (
        <VStack
            align="flex-start"
            spacing={7}
            width={{ base: "100%", lg: "80%" }}
        >
            <Title paddingBottom="10px">Entre com a sua conta:</Title>
            <Tabs colorScheme="primaryScheme" isFitted width="100%">
                <TabList>
                    <Tab>CPF</Tab>
                    <Tab>CNPJ</Tab>
                    <Tab>Email</Tab>
                </TabList>
                <TabPanels paddingTop="30px">
                    <TabPanel padding="0px">
                        <RFHMaskedInput
                            value={username}
                            onChange={(e) =>
                                setUsername(
                                    e.target.value
                                        .replace(/\./g, "")
                                        .replace("-", "")
                                )
                            }
                            placeholder="CPF"
                            mask="999.999.999-99"
                        />
                    </TabPanel>
                    <TabPanel padding="0px">
                        <RFHMaskedInput
                            value={username}
                            onChange={(e) =>
                                setUsername(
                                    e.target.value
                                        .replace(/\./g, "")
                                        .replace("-", "")
                                        .replace("/", "")
                                )
                            }
                            placeholder="CPF"
                            mask="99.999.999/0001-99"
                        />
                    </TabPanel>
                    <TabPanel padding="0px">
                        <Input
                            value={username}
                            onChange={setUsername}
                            placeholder="Email"
                            type="email"
                        />
                    </TabPanel>
                </TabPanels>
            </Tabs>
            <VStack width="100%" spacing={2}>
                <PasswordInput
                    pr="4.5rem"
                    value={password}
                    onChange={setPassword}
                    placeholder="Senha"
                />
                <Link
                    fontSize="10px"
                    alignSelf="end"
                    textDecoration="underline !important"
                    margin="0px"
                    href={`https://api.partiu.com.br/password_reset/?agreement_id=${id}`}
                    target="_blank"
                >
                    Esqueci minha senha
                </Link>
            </VStack>

            <Spacer />
            <Button
                width="100%"
                isLoading={loginMutation.isLoading}
                onClick={loginMutation.mutate}
            >
                Entrar
            </Button>
        
            <Link
                href="#"
                fontSize="14px"
                alignSelf="center"
                textDecoration="underline !important"
                onClick={() => navigate("/login")}
            >
                Não tenho uma conta
            </Link>
            {bookstoreModule && <Text paddingTop={"8px"} paddingBottom={"56px"} fontSize={12}>
                Cancelou o seu plano com a {name}? Sem problemas, faça login acima, e se estiver esquecido sua senha, basta clicar em "Esqueci minha senha"
            </Text>}

            <Text textAlign="left" color="#888" fontSize="12px">
                Alguns clientes {name} possuem acesso gratuito {bookstoreType === 'book' ? 'a livros e acervos' : ''}
            </Text>
        </VStack>
    );
}
